<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  class="lucide lucide-table2-icon lucide-table-2"
>
  <path fill="currentColor" stroke="none" d="M9 3h10a2 2 0 0 1 2 2v4H9z" />
  <path fill="currentColor" stroke="none" d="M3 9h6v12H5a2 2 0 0 1-2-2z" />
  <path
    d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"
  />
</svg>
